import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './emptyState.css';

// Shared client-view empty state — matches the dashed icon/title/text card used
// by Apartment Setup and the bookings list. Use `compact` for empty states that
// sit inside another card (e.g. a per-property row).
export default function EmptyState({ icon, title, text, compact = false, children }) {
    return (
        <div className={`cv-empty${compact ? ' cv-empty--compact' : ''}`}>
            {icon && <FontAwesomeIcon icon={icon} className="cv-empty__icon" />}
            {title && <div className="cv-empty__title">{title}</div>}
            {text && <div className="cv-empty__text">{text}</div>}
            {children}
        </div>
    );
}
